import { LanguageService } from './../../services/language.service';
import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";

import {IOption} from "ng-select";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {Restangular} from "ngx-restangular";
import {AuthenticationService} from "../../services/authentication.service";
import {Globals} from "../../services/globals";
import {HelperService} from "../../services/helper.service";
import {MenuService} from "../../services/menu.service";
import {AppResetPasswordComponent} from "../app-reset-password/app-reset-password.component";
import { DropdownService } from 'app/services/dropdown.service';
import { take } from 'rxjs/operators';

@Component({
  selector: "app-sidebar-nav",
  template: `
      <br>
              <fieldset class="form-group">
                  <ng-select
                  class="bootstrap"
                  (selected)="onSelected0($event)"
                  placeholder="Choose a company"
                  [options]="companies"
                  [(ngModel)]="selectedCompany"
                  [allowClear]="false"></ng-select>
                </fieldset>
      <div class="down hide">
          <a><img [src]="profilePic" style="border: 3px solid white !important;"></a>
          <a><span class="name-caret" style="padding: 1px;font-size: 1.3em;">{{profileName}}</span></a>
          <p class=" text-center  text-muted text-uppercase small">{{profile?.company?.CompanyName}}</p>
      </div>
      <nav class="sidebar-nav">
          <ul class="nav" *ngIf="menuLoaded">
              <ng-template ngFor let-navitem [ngForOf]="navigation">
                  <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
                  <ng-template [ngIf]="isTitle(navitem)">
                      <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
                  </ng-template>
                  <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)">
                      <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
                  </ng-template>
              </ng-template>
          </ul>
      </nav>`,
  providers: [AuthenticationService, MenuService],
  styleUrls: [
    "../../../scss/vendors/ng-select/ng-select.scss",
  ],
})
export class AppSidebarNavComponent implements OnInit, OnDestroy {

  public profile: any = {};
  public profilePic: string = "profileImage/default.png";
  public profileName: string = "";
  public navigation: any[] = [];
  public menuLoaded: boolean = false;
  public companies: IOption[] = [];
  public selectedCompany: number[] = [];
  showApprovalCount: boolean = true;
  public welcomeMenu: any = {
    title: true,
    name: "",
  };
  bsModalRefCorrectiveAction: BsModalRef;

  constructor(private restangular: Restangular,
              private globals: Globals,
              private route: ActivatedRoute,
              private modalService: BsModalService,
              private authenticationService: AuthenticationService,
              private menuService: MenuService,
              private helperService: HelperService,
              private languageService: LanguageService) {

    this.loaded();
    this.languageService.invokeEvent.subscribe(value => {
        this.getCurrentUserInfo()
     })
  }

  public ngOnDestroy() {
    if (this.bsModalRefCorrectiveAction) {
      this.bsModalRefCorrectiveAction.hide();
    }
  }

  public loaded() {

    if (localStorage.getItem("access_token")) {
        this.getCompanies();
      this.getCurrentUserInfo();
    } else {

      this.authenticationService.logout();
    }
  }

  public getCompanies() {
    const that = this;
    this.menuService
      .getCompanies()
      .get()
      .subscribe((data) => {

        this.companies = data.data.companies;
        this.selectedCompany = [+data.data.default_company];
        sessionStorage.setItem("selectedCompany", data.data.default_company);
      }, () => {
      });
  }

  resetPassword() {
    this.bsModalRefCorrectiveAction = this.modalService.show(AppResetPasswordComponent, {
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    });
  }

  public getCurrentUserInfo() {
    const that = this;
    this.authenticationService.getCurrentUserInfo().get()
      .subscribe((resp) => {
        that.profile = resp.data;
        if (that.profile.profileImage) {
          that.profilePic = that.profile.profileImage;
          that.profileName = that.profile.empName;
        }
        sessionStorage.setItem("uid", that.profile.employeeSystemID);
        sessionStorage.getItem("uid");
        that.selectedCompany = [+that.profile.empCompanySystemID];
        sessionStorage.setItem("selectedCompany", that.profile.empCompanySystemID);
        localStorage.setItem("selectedCompany", that.profile.empCompanySystemID);

        that.globals.isInitialLogin = that.profile.isInitialLogin;
        if (that.profile.company) {
          that.globals.isLeadershipBoard = that.profile.company.isLeadershipBoard;
          that.globals.isAssignment = that.profile.company.isAssignment;
          that.globals.isTrainingProgram = that.profile.company.isTrainingProgram;
          that.globals.isTraining = that.profile.company.isTraining;
          that.globals.isQuestionnaire = that.profile.company.isQuestionnaire;
          that.globals.isSurvey = that.profile.company.isSurvey;
          that.globals.isRecognition = that.profile.company.isRecognition;
          that.globals.isUserGuide = that.profile.company.isUserGuide;
          that.globals.showUserList = that.profile.company.showUserList;
        }

        /*if (that.globals.isInitialLogin && +this.helperService.getSelectedCompanyId() == 3) {
          this.helperService.goToProfile();
        } else if (that.globals.isLeadershipBoard) {
          this.helperService.go("reports/leadership-board-report");
        }*/
        if (that.globals.isInitialLogin) {
          that.resetPassword();
        }
        console.log(that.profile);
        this.getMenu(that.profile.empCompanySystemID);
      }, (error) => {
        console.log('Current User Info Error: ');
        this.checkUser();
      });
  }

  checkUser() {
    this.authenticationService
      .checkAuth()
      .get()
      .subscribe(resp => {
        this.getCurrentUserInfo();
      }, (error) => {
        if (localStorage.getItem('refresh_token')) {
          this.refreshToken();
        } else {
          this.authenticationService.logout();
        }
      });
  }

  refreshToken() {
    this.authenticationService.refreshToken()
      .subscribe(
        data => {
          this.getCurrentUserInfo();
        },
        error => {
          this.authenticationService.logout();
        });
  }

  public onSelected0(data) {
    console.log(data);
    localStorage.setItem('selectedCompany',data['value']);
    sessionStorage.setItem("selectedCompany", data.value);
    // check for datatable filter exist and remove the filter
    if (sessionStorage.getItem("DataTables_filter") !== null) {
      sessionStorage.removeItem("DataTables_filter");
    }
    this.getMenu(data.value);
    this.helperService.go("dashboard");
  }

  getApprovalCounts(companyId) {
    this.menuService
      .getApprovalCounts()
      .get({'companyId': companyId})
      /*.delay(1000)*/
      .subscribe((data) => {
        let resp = data.data.data;
        this.setApprovalCount(resp);
      }, (error) => {
        console.log(error);
      });
  }

  correctiveActionCounts(companySystemID) {
    this.menuService
      .getCorrectiveActionCounts()
      .get({'companySystemID': companySystemID})
      /*.delay(1000)*/
      .subscribe((data) => {
        let resp = data.data.data;
        this.setActionItemsCount(resp.count);
      }, (error) => {
        console.log(error);
      });
  }

  getDmsApprovalCounts(){
    this.menuService
    .getDmsApprovalCount()
    .get()
    /*.delay(1000)*/
    .subscribe((data) => {
      let resp = data.data.data;
      this.setDmsApprovalCount(resp.count);
    }, (error) => {
      console.log(error);
    });
  }

  public setApprovalCount(data) {
    for (let i = 0; i < this.navigation.length; i++) {
      if (this.navigation[i].navId == 62) {
        if (this.navigation[i].children) {
          for (let j = 0; j < this.navigation[i].children.length; j++) {
            let id = this.navigation[i].children[j].navId;
            let found = data.find(ele => ele.id == id);
            if (found && found.count > 0) {
              this.navigation[i].children[j].badge = {
                variant: "danger",
                text: found.count,
              };
            }
          }
        }
        let id = this.navigation[i].navId;
        let found = data.find(ele => ele.id == id);
        if (found && found.count > 0) {
          this.navigation[i].badge = {
            variant: "danger",
            text: found.count,
          };
        }
        break;
      }
    }
  }

  public setActionItemsCount(data) {
    if (data > 0) {
      for (let i = 0; i < this.navigation.length; i++) {
        if (this.navigation[i].navId == 2) {
          this.navigation[i].badge = {
            variant: "danger",
            text: data,
          };
          break;
        }
      }
    }
  }

  public setDmsApprovalCount(data){
    for (let i = 0; i < this.navigation.length; i++) {
      if (this.navigation[i].navId == 105) {
        if (this.navigation[i].children) {
          for (let j = 0; j < this.navigation[i].children.length; j++) {
            let id = this.navigation[i].children[j].navId;
            if (id === 108 && data > 0) {
              this.navigation[i].children[j].badge = {
                variant: "danger",
                text: data,
              };
            }
          }
        }
        break;
      }
    }
  }

  public getMenu(companyId) {
    this.menuLoaded = false;
    this.menuService
      .getMenuByCompany()
      .get({companyId})
      /*.delay(1000)*/
      .subscribe((data) => {
        this.navigation = [];
        //this.navigation.push(this.welcomeMenu);
        const menu = data.data.data;

        for (let i = 0; i < menu.length; i++) {
          const modal: any = {
            navId: menu[i].navigationMenuID,
            name: (menu[i].localize[0] != undefined) ? menu[i].localize[0].description : menu[i].description,
            url: menu[i].url == "" ? "/pages" : "/" + menu[i].url,
            icon: menu[i].pageIcon, //'icon-speedometer',
            badge: {
              variant: "",
              text: "",
            },
          };
          for (let k = 0; k < menu[i].child.length; k++) {
            if (k == 0) {
              modal.children = [];
            }
            const child: any = menu[i].child[k];

            const temChild: any = {
              navId: child.navigationMenuID,
              name: (child.localize[0] != undefined) ? child.localize[0].description : child.description,
              url: child.url == "" ? "/pages" : "/" + child.url,
              icon: child.pageIcon, //'icon-speedometer',
              badge: {
                variant: "",
                text: "",
              },
            };

            for (let n = 0; n < child.child.length; n++) {
              if (n == 0) {
                temChild.children = [];
              }
              const sec_child: any = child.child[n];
              temChild.children.push({
                navId: sec_child.navigationMenuID,
                name: sec_child.description,
                url: "/" + sec_child.url,
                icon: sec_child.pageIcon, //'icon-speedometer',
                badge: {
                  variant: "",
                  text: "",
                },
              });
            }
            modal.children.push(temChild);
          }
          this.navigation.push(modal);
        }
        if (this.showApprovalCount) {
          this.getApprovalCounts(companyId);
          this.correctiveActionCounts(companyId);
          this.getDmsApprovalCounts();
        }
        this.menuLoaded = true;
      }, (error) => {
        console.log(error);
      });
  }

  public ngOnInit() {
  }

  public isDivider(item) {
    return item.divider ? true : false;
  }

  public isTitle(item) {
    return item.title ? true : false;
  }

}

@Component({
  selector: "app-sidebar-nav-item",
  template: `
      <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
          <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
      </li>
      <ng-template #dropdown>
          <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'sd nav-item nav-dropdown'"
              [class.open]="isActive()"
              routerLinkActive="open"
              appNavDropdown>
              <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
          </li>
      </ng-template>
  `,
})
export class AppSidebarNavItemComponent {
  @Input() public item: any;

  public hasClass() {
    return this.item.class ? true : false;
  }

  public isDropdown() {
    return this.item.children ? true : false;
  }

  public thisUrl() {

    return this.item.url;
  }

  public isActive() {
   //  $('.sd').removeClass('open');
    return this.router.isActive(this.thisUrl(), false);
  }
  public isDropdownOpen() {
    let isOpen: boolean;
  
    this.dropdownService.openDropdown$.pipe(take(1)).subscribe((currentDropdown) => {
      isOpen = this.item.name === currentDropdown;
    });
  
    return isOpen;
  }

  constructor(private router: Router,private dropdownService: DropdownService) {
  }

}

@Component({
  selector: "app-sidebar-nav-link",
  template:
      `<span *ngIf="globals.isInitialLogin">
        <a *ngIf="!isExternalLink(); else external"
           [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link ' + globals.theme"
           routerLinkActive="active"
           class="disabled"
           [routerLink]="[getLink(link)]">
            <i *ngIf="isIcon()" class="{{ link.icon }} nav-item-icon"></i>
            {{ link.name }}
            <span *ngIf="isBadge()"
                  [ngClass]="'badge badge-pill-nav badge-' + link.badge.variant">{{ link.badge.text }}</span>
        </a>
        <ng-template #external>
            <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link ' + globals.theme"
               class="disabled"
               href="{{getLink(link)}}">
                <i *ngIf="isIcon()" class="{{ link.icon }} nav-item-icon {{globals.themeFont}}"></i>
                {{ link.name }}
                <span *ngIf="isBadge()"
                      [ngClass]="'badge badge-pill-nav badge-' + link.badge.variant">{{ link.badge.text }}</span>
            </a>
        </ng-template>
         </span>
  <span *ngIf="!globals.isInitialLogin">
        <a *ngIf="!isExternalLink(); else external"
           [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link ' + globals.theme"
           routerLinkActive="active"
           [routerLink]="[getLink(link)]">
            <i *ngIf="isIcon()" class="{{ link.icon }} nav-item-icon {{globals.themeFont}}"></i>
            {{ link.name }}
            <span *ngIf="isBadge()"
                  [ngClass]="'badge badge-pill-nav badge-' + link.badge.variant">{{ link.badge.text }}</span>
        </a>
        <ng-template #external>
            <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link ' + globals.theme"
               href="{{getLink(link)}}">
                <i *ngIf="isIcon()" class="{{ link.icon }} nav-item-icon {{globals.themeFont}}"></i>
                {{ link.name }}
                <span *ngIf="isBadge()"
                      [ngClass]="'badge badge-pill-nav badge-' + link.badge.variant">{{ link.badge.text }}</span>
            </a>
        </ng-template>
         </span>`,
})
export class AppSidebarNavLinkComponent {
  @Input() public link: any;

  public hasVariant() {
    return this.link.variant ? true : false;
  }

  public isBadge() {
    return this.link.badge ? true : false;
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === "http" ? true : false;
  }

  public isIcon() {
    return this.link.icon ? true : false;
  }

  constructor(private helperService: HelperService,
              public globals: Globals,
              private authenticationService: AuthenticationService,) {
  }

  public getLink(item) {
    if (this.globals.isInitialLogin && +this.helperService.getSelectedCompanyId() == 3) {
      return "configuration/profile-alkhoraye";
    }
    return item.url;
  }
}

@Component({
  selector: "app-sidebar-nav-dropdown",
  template: `
  <a
  class="nav-link nav-dropdown-toggle {{globals.theme}}"
  appNavDropdownToggle
  href="#"
  (click)="toggleDropdown()"
>
  <i *ngIf="isIcon()" class="{{ link.icon }} nav-root-item-icon {{globals.themeFont}}"></i>
  {{ link.name }}
  <span *ngIf="isBadge()" [ngClass]="'badge badge-pill-nav badge-' + link.badge.variant"
    >{{ link.badge.text }}</span
  >
</a>
<ul class="nav-dropdown-items">
  <ng-template ngFor let-child [ngForOf]="link.children">
    <app-sidebar-nav-item [item]="child"></app-sidebar-nav-item>
  </ng-template>
</ul>
  `,
})
export class AppSidebarNavDropdownComponent {
  @Input() public link: any;

  public isBadge() {
    return this.link.badge ? true : false;
  }

  public isIcon() {
    return this.link.icon ? true : false;
  }

  constructor(public globals: Globals, private dropdownService: DropdownService) {}

  toggleDropdown() {
    this.dropdownService.openDropdown$.subscribe((currentDropdown) => {
      const isOpen = this.link.name === currentDropdown;
      if (isOpen) {
        this.dropdownService.setOpenDropdown(null);
      } else {
        this.dropdownService.setOpenDropdown(this.link.name);
      }
    });
  }

}

@Component({
  selector: "app-sidebar-nav-title",
  template: "",
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() public title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  public ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement("li");
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, "nav-title");

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper && this.title.wrapper.element) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li);
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent,
];



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts